export default "__VITE_PUBLIC_ASSET__b327921a__"